import { Box, Toolbar } from '@mui/material';
import { useState, type ReactNode } from 'react';

import { Breadcrumbs } from './Breadcrumbs.js';
import { Header } from './Header.js';
import { NewVersionBanner } from './NewVersionBanner.js';
import { Sidebar } from './Sidebar.js';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps): JSX.Element {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
      <Box component="main" sx={{ flexGrow: 1, minWidth: 0 }}>
        <Header onMenu={() => setMenuOpen(true)} />
        <Toolbar />
        <Box sx={{ p: { xs: 2, md: 4 }, width: '100%', minWidth: 0 }}>
          <NewVersionBanner />
          <Breadcrumbs />
          {children}
        </Box>
      </Box>
    </Box>
  );
}
